import { c as _c } from "react/compiler-runtime";
import type { DataIdentifier, DocumentKind } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import type useEntityVault from '@/components/entities/hooks/use-entity-vault';
import { useEntityContext } from '@/entity/hooks/use-entity-context';
import useDataLabelText from '../../../hooks/use-data-label-text';
import getDataValue from '../../../utils/get-data-value';
import Decrypt from './decrypt';
export type IdentityDataContentProps = {
  documentKind: DocumentKind;
  vault: ReturnType<typeof useEntityVault>;
  isDecrypted: boolean;
  canDecrypt: boolean;
  dis: DataIdentifier[];
  seqno: number | undefined;
};
const IdentityDataContent = t0 => {
  const $ = _c(23);
  const {
    documentKind,
    vault,
    isDecrypted,
    canDecrypt,
    dis,
    seqno
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset.documents.details.identity"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const dataLabelT = useDataLabelText();
  const {
    kind: entityKind
  } = useEntityContext();
  if (!isDecrypted) {
    let t2;
    if ($[1] !== seqno) {
      t2 = seqno?.toString();
      $[1] = seqno;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== canDecrypt || $[4] !== documentKind || $[5] !== entityKind || $[6] !== t2 || $[7] !== vault.data || $[8] !== vault.update) {
      t3 = <Decrypt documentType={documentKind} onDecryptSuccess={vault.update} canDecrypt={canDecrypt} vaultData={vault.data} seqno={t2} entityKind={entityKind} />;
      $[3] = canDecrypt;
      $[4] = documentKind;
      $[5] = entityKind;
      $[6] = t2;
      $[7] = vault.data;
      $[8] = vault.update;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    return t3;
  }
  if (dis.length === 0) {
    let t2;
    if ($[10] !== t) {
      t2 = t(_temp);
      $[10] = t;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    let t3;
    if ($[12] !== t2) {
      t3 = <span className="text-body-2 text-tertiary">{t2}</span>;
      $[12] = t2;
      $[13] = t3;
    } else {
      t3 = $[13];
    }
    return t3;
  }
  let t2;
  if ($[14] !== dataLabelT || $[15] !== dis || $[16] !== vault) {
    let t3;
    if ($[18] !== dataLabelT || $[19] !== vault) {
      t3 = key => {
        const vaultValue = vault.data?.vault[key];
        const value = getDataValue(vaultValue, key);
        return <div key={key} className="flex justify-between gap-6"><p className="text-body-2 text-tertiary">{dataLabelT(key)}</p><p className="text-body-2 text-primary text-right wrap-anywhere md:wrap-normal" title={value} data-dd-privacy="mask">{value}</p></div>;
      };
      $[18] = dataLabelT;
      $[19] = vault;
      $[20] = t3;
    } else {
      t3 = $[20];
    }
    t2 = dis.map(t3);
    $[14] = dataLabelT;
    $[15] = dis;
    $[16] = vault;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  let t3;
  if ($[21] !== t2) {
    t3 = <div className="flex flex-col gap-2 w-full">{t2}</div>;
    $[21] = t2;
    $[22] = t3;
  } else {
    t3 = $[22];
  }
  return t3;
};
export default IdentityDataContent;
function _temp($) {
  return $.empty;
}